import React from "react"
import { auth } from "./firebase"
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
} from "firebase/auth"

const Login = ({ onLogin }: { onLogin: () => void }) => {
  const [email, setEmail] = React.useState("")
  const [password, setPassword] = React.useState("")
  const [isLogin, setIsLogin] = React.useState(true)
  const [error, setError] = React.useState("")

  const handleSubmit = async () => {
    setError("")

    try {
      if (isLogin) {
        await signInWithEmailAndPassword(auth, email, password)
      } else {
        await createUserWithEmailAndPassword(auth, email, password)
      }

      onLogin()
    } catch (err: any) {
      setError(err.message)
    }
  }

  return (
    <div style={{ padding: 40 }}>
      <h2>{isLogin ? "Login" : "Sign Up"}</h2>

      <input
        placeholder="Email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />

      <input
        type="password"
        placeholder="Password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
      />

      <button onClick={handleSubmit}>
        {isLogin ? "Login" : "Create Account"}
      </button>

      <p onClick={() => setIsLogin(!isLogin)} style={{ cursor: "pointer" }}>
        {isLogin ? "Create account" : "Already have an account?"}
      </p>

      {error && <p style={{ color: "red" }}>{error}</p>}
    </div>
  )
}

export default Login